export const hologramIconsTrailers = [
    {
        sources: [{src: 'https://ads-staticpool.filmon.com/filmon/ss.trailer1.mp4'}],
        poster: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster1.jpg',
        thumbnail: [
            {
                srcset: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster1.jpg',
                type: 'image/jpeg',
                media: '(min-width: 400px;)'
            }
        ],
        name: "Trailer 1",
    },
    {
        sources: [{src: 'https://ads-staticpool.filmon.com/filmon/ss.trailer2.mp4'}],
        poster: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster2.jpg',
        thumbnail: [
            {
                srcset: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster2.jpg',
                type: 'image/jpeg',
                media: '(min-width: 400px;)'
            }
        ],
        name: "Trailer 2",
    },
    {
        sources: [{src: 'https://ads-staticpool.filmon.com/filmon/ss.trailer3.mp4'}],
        poster: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster3.jpg',
        thumbnail: [
            {
                srcset: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster3.jpg',
                type: 'image/jpeg',
                media: '(min-width: 400px;)'
            }
        ],
        name: "Trailer 3",
    },
    {
        sources: [{src: 'https://ads-staticpool.filmon.com/filmon/ss.trailer4.mp4'}],
        poster: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster4.jpg',
        thumbnail: [
            {
                srcset: 'https://www.filmon.com/tv/themes/filmontv/images/event/scott/poster4.jpg',
                type: 'image/jpeg',
                media: '(min-width: 400px;)'
            }
        ],
        name: "Trailer 4",
    },
];

export const hologramIconsStreams = [
    {
        url: '/vr-streams/6149.high/playlist.m3u8',
        quality: 'high'
    }, {
        url: '/vr-streams/6149.low/playlist.m3u8',
        quality: 'low'
    },
];
